import * as React from 'react';
const classNames = require('classnames');

import Checkbox, { CheckboxProps } from './Checkbox';
import Label from './Label';

interface Props {
	title?: {};
	name?: string;
	checkOptions: Array<CheckboxProps>;
	className?: string;
	children?: {};
}

const CheckboxGroup: React.StatelessComponent<Props> = props => {
	return (
		<div className={classNames('form-group', props.className)}>
			<Label>{props.title}</Label>
			{props.checkOptions.map((check, index) => (
				<Checkbox key={index} {...check} />
			))}
			{props.children}
		</div>
	);
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/CheckboxGroup.tsx